<template>
    <v-container fluid class="pa-0 ma-0">
        <v-toolbar flat color="white">
            <!--Authorization FORM-->
            <template v-if="type == 'form'">
                <v-toolbar-title >{{ formTitle }}</v-toolbar-title>
                <v-spacer></v-spacer>
                <div v-if="this.id && !isClone">
                    <responsiveButton :setClick="confirmClone"
                                      setColor="purple"
                                      setDefaultIcon="mdi-content-copy"
                                      setSmallIcon="mdi-content-copy"
                    class="mr-2"
                    >
                        Clone
                    </responsiveButton>
                    <responsiveButton :setClick="confirmNew"
                                      setColor="blue"
                                      setDefaultIcon="mdi-plus"
                                      setSmallIcon="mdi-plus-circle-outline"
                    >
                        New
                    </responsiveButton>
                </div>
            </template>
            <!--Authorization VIEW TABLE-->
            <template v-if="type == 'view'">
                <v-toolbar-title>Authorization Table </v-toolbar-title>
                <v-spacer></v-spacer>
                <responsiveButton :setTo="{name: 'clientAuthorizationAdd'}"
                                  setColor="blue"
                                  setDefaultIcon="mdi-plus"
                                  setSmallIcon="mdi-plus-circle-outline"
                >
                    Add Authorization
                </responsiveButton>
            </template>
        </v-toolbar>
        <v-divider class="my-0 mx-6"></v-divider>
        <dialog-alert
                :text="alert.text"
                :alertType="alert.type"
                :open="alert.show"
                @alert-closed="alert.click($event)">
        </dialog-alert>
    </v-container>
</template>

<script>
    const responsiveButton = () => import('@/components/common/mobile/Button');
    const DialogAlert = ()=> import( '@/components/common/DialogAlert');
    import alertEventBus from '@/eventBus/AlertEventBus';
    import {AUTHORIZATION_STATUS} from '@/shared/enums/EntitiesStatus';
    const uuidv4 = require('uuid/v4');

    export default {
        name: "ClientHeader",
        props:["hType", "path_id"],
        components:{responsiveButton, DialogAlert},
        data(){
            return{
                type: this.hType,
                id: this.path_id,
                alert:{
                    text:'',
                    type:'info',
                    show: false,
                    click:()=> true,
                }
            }
        },
        watch:{
            hType(value){
                this.type = value;
            },
            path_id(value){
                this.id = value;
            }
        },
        computed:{
            formTitle () {
                let title = this.id != undefined ? 'Edit authorization' : 'New authorization';
                if(this.isClone){
                  title = 'Clone authorization';
                }

                return title;
            },
            isClone(){
              return this.$route.fullPath.includes('clone');
            }
        },
        methods:{
            confirmClone(event){
                this.alert.text = 'The information about the authorization will ' +
                    'be erase and replace with the clone after saving it';
                this.alert.type = 'warning';
                this.alert.click = (isOk) => this.sendToClone(isOk);
                this.alert.show = true;
                this.$log.debug('confirm to Clone');
            },
            async sendToClone(isOk){
                this.alert.show = false;
                if(!isOk){
                    return;
                }
                this.$log.debug('sending to Clone')
                try{
                    await this.$store.dispatch("getClient", {id:this.id});
                    let client = this.$store.getters.getClient;
                    let authorizationRecord = client.authorizationRecord;
                    if(!!!authorizationRecord){
                        this.$log.debug('no record to update');
                        this.refreshPage('clientAuthorizationClone');
                        return ;
                    }

                    await this.disableAuthorization(authorizationRecord.authorizationRecordId);
                    this.refreshPage('clientAuthorizationClone');
                }
                catch (e) {
                    alertEventBus.setAlert({type:'error', msg: e.message});
                }
            },
            confirmNew(event){
                this.$log.debug('confirm to New');
                this.alert.text = 'The information about the authorization will ' +
                    'be erase and replace with the new authorization after saving it';
                this.alert.type = 'warning';
                this.alert.click = (isOk) => this.sendToNew(isOk);
                this.alert.show = true;
            },
            async sendToNew(isOk){
                this.alert.show = false;
                if(!isOk){
                    return;
                }
                this.$log.debug('sending to New')
                //we need to clear client authorization record
                try{
                    await this.$store.dispatch("getClient", {id:this.id});
                    let client = this.$store.getters.getClient;
                    let authorizationRecord = client.authorizationRecord;
                    if(!!!authorizationRecord){
                        this.$log.debug('no record to update');
                        this.refreshPage('clientAuthorizationAssignment')
                        return ;
                    }

                    delete client.authorizationRecord;
                    await this.disableAuthorization(authorizationRecord.authorizationRecordId);
                    await this.$store.dispatch("setClient", client);

                    this.refreshPage('clientAuthorizationAssignment');
                }
                catch (e) {
                    alertEventBus.setAlert({type:'error', msg: e.message});
                }
            },
            async disableAuthorization(authId){
                await this.$store.dispatch('getAuthorizationRecord', {id: authId});
                let auth = this.$store.getters.getAuthorizationRecord;
                auth.status = AUTHORIZATION_STATUS.INACTIVE.status;
                await this.$store.dispatch('setAuthorizationRecord', auth);
            },
            refreshPage(toName){
                //the uuid is to make the path different and the screen be able to refresh
                this.$router.push({name: toName, params:{path_id: this.id}, query:{uid: uuidv4()}});
            }
        }
    }
</script>

<style scoped>

</style>